export const scContent = {
    "Your ifc Points:": "您的ifc积分:",
    "ifc Points": "ifc积分",
    "Out of stock": "已换罄 ",
    "Low in stock": "尚余少量",
    "Redemption period": "换领期",
    "Valid until": "有效期至",
    "Required ifc Points: ": "所需ifc积分：",
    "Redeem": "换领",
    "Confirm to redeem with x,xxx ifc Points? ": "是否确认以 {points} ifc积分换领？ ",
    "Quantity": "数量： ",
    "pc(s)": "",
    "Click \"Confirm\" to proceed.": "按「确认」以继续。",
    "The redemption cannot be cancelled or changed after confirmation.": "确认后将无法取消或更改。",
    "Cancel": "取消",
    "Confirm": "确认",
    "Done": "完成 ",
    "Check Rewards": "查看奖赏",
    "Check Gift Voucher": "查看礼券",    
    "You have successfully redeemed:": "您已成功换领 ： ",
    "Sorry, something went wrong.": "抱歉，发生错误。",
    "Please check your network settings and try again.": "请检查网络设定然后再试。",
    "OK": "明白"    
}